import { render, staticRenderFns } from "./setDataWedge.vue?vue&type=template&id=0b96c57e&scoped=true"
import script from "./setDataWedge.vue?vue&type=script&lang=js"
export * from "./setDataWedge.vue?vue&type=script&lang=js"
import style0 from "./setDataWedge.vue?vue&type=style&index=0&id=0b96c57e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b96c57e",
  null
  
)

export default component.exports